<template>
  <div>
    <b-row>
      <b-col>
        <header-view
          :title="$t('message.contactPersonList.title')"
          :icon="'ti-user'">
        </header-view>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-card class="rounded-0">
          <b-row>
            <b-col>
              <p>{{ $t('message.contactPersonList.introductoryPhrase') }}</p>
            </b-col>
          </b-row>
          <b-row
            v-for="i in Math.ceil(contactPersons.length / 2)"
            class="mb-lg-4"
            :key="i">
            <b-col
              v-for="contactPerson in contactPersons.slice((i - 1) * 2, i * 2)"
              cols="12"
              xl="6"
              class="mt-md-4 mt-lg-0"
              :key="contactPerson.id + contactPerson.name">
              <div
                class="p-0 m-0 w-100 cursor-pointer"
                variant="transparent"
                router-tag="div"
                :class="{'not-allowed' : contactPerson.status !== $t('enums.invitationStatus.REGISTERED')}"
                @click="showContactPerson(contactPerson)">
                <business-card
                  class="rounded-0 h-100"
                  :name="contactPerson.name"
                  :relation="contactPerson.relationshipType? $t('enums.relationTypes.' + contactPerson.relationshipType) : null"
                  :email="contactPerson.email"
                  :status="contactPerson.status"
                  :imageSrc="contactPerson.avatarUuid">
                </business-card>
              </div>
            </b-col>
            <b-col
              v-if="i == Math.ceil(contactPersons.length / 2)"
              cols="12"
              xl="6"
              :class="{'mt-4' : contactPersons.length % 2 === 0}">
              <b-btn
                class="w-100 h-100 pt-4 pb-2 rounded-0"
                @click="showContactPersonDialog">
                <span class="ti-plus font-weight-bold pt-1"
                      :style="'font-size: 4rem; border: 1px solid #fff; border-radius: 3rem; padding: 5px;'"></span>
                <p class="mt-4">{{ $t('message.contactPersonList.btn.createContactPerson') }}</p>
              </b-btn>
            </b-col>
          </b-row>
          <b-row
            v-if="contactPersons.length === 0">
            <b-col cols="6">
              <b-btn
                class="w-100 h-100 pt-4 pb-2 rounded-0"
                @click="showContactPersonDialog">
                <span class="ti-plus font-weight-bold pt-1"
                      :style="'font-size: 4rem; border: 1px solid #fff; border-radius: 3rem; padding: 5px;'"></span>
                <p class="mt-4">{{ $t('message.contactPersonList.btn.createContactPerson') }}</p>
              </b-btn>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <contact-person-dialog
      ref="contactPersonDialog"
      @submit="submitContactPersonDialog">
    </contact-person-dialog>
  </div>
</template>
<script>
  import BusinessCard from '@/components/common/BusinessCard'
  import HeaderView from '@/components/common/HeaderView'
  import ContactPersonDialog from '@/components/contactPerson/ContactPersonDialog'

  export default {
    name: 'ContactPersonList',
    components: {
      BusinessCard,
      ContactPersonDialog,
      HeaderView
    },
    created () {
      this.$store.dispatch('fetchContactPersons')
      this.$store.dispatch('fetchInvitations')
    },
    computed: {
      contactPersons () {
        const mappedContactPersons = this.$store.getters.contactPersons.map(contactPerson => {
          return {
            id: contactPerson.id,
            avatarUuid: contactPerson.avatarUuid,
            name: contactPerson.firstName + ' ' + contactPerson.lastName,
            email: contactPerson.email,
            status: this.$t('enums.invitationStatus.REGISTERED')
          }
        })
        const mappedInvitations = this.$store.getters.invitations.map(invitation => {
          return {
            id: invitation.id,
            name: invitation.contactPersonFirstname + ' ' + invitation.contactPersonLastname,
            email: invitation.contactPersonEmail,
            status: this.$t('enums.invitationStatus.' + invitation.status)
          }
        })
        return mappedContactPersons.concat(mappedInvitations)
      }
    },
    methods: {
      showContactPerson (contactPerson) {
        if (contactPerson.status === this.$t('enums.invitationStatus.REGISTERED')) {
          this.$router.push('/contactpersons/' + contactPerson.id)
        }
      },
      showContactPersonDialog () {
        this.$refs.contactPersonDialog.show()
      },
      submitContactPersonDialog (contactPerson) {
        this.$store.dispatch('inviteContactPerson', contactPerson)
          .then(() => {
            this.showSuccessMsg({
              message: this.$t('message.contactPersonList.submitContactPersonDialog', {email: contactPerson.email})
            })
          })
          .catch(() => {
            this.showErrorMsg({
              message: this.$t('error.contactPersonList.submitContentPersonDialog') // TODO i18n
            })
          })
      }
    },
    notifications: {
      showErrorMsg: {
        type: 'error'
      },
      showSuccessMsg: {
        type: 'success'
      }
    }
  }
</script>

<style scoped>
  .btn:focus {
    box-shadow: none;
  }

  .not-allowed {
    cursor: not-allowed !important;
  }
  .cursor-pointer
  {
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/contactPerson/ContactPersonList.vue